import { useAppSelector } from 'app/store';
import { getUserGuid } from 'app/store/Auth/selectors';
import { useState } from 'react';

export const useCloseStorageBanner = () => {
  const userGuid = useAppSelector(getUserGuid);
  const storageKey = `storage-banner-closed-${userGuid}`;
  const [storageBannerClosed, setStorageBannerClosed] = useState(
    localStorage.getItem(storageKey) === 'true'
  );

  const onCloseStorageBanner = () => {
    localStorage.setItem(storageKey, 'true');
    setStorageBannerClosed(true);
  };

  return {
    onCloseStorageBanner,
    storageBannerClosed,
  };
};
